import type React from 'react';

import { useSearchResults } from '#src/app/pages/search/shared/searchState';

import { HitCard } from '../HitCard';
import { Pagination } from '../Pagination';
import { SearchResultList } from '../SearchResultList';

export const ResultsContent: React.FC = () => {
	const results = useSearchResults();

	return (
		<div className="col-span-12 md:col-span-8">
			<SearchResultList>
				<ul aria-live="polite" className="divide-stroke-weaker grid grid-cols-1 divide-y">
					{results.hits.map((hit) => (
						<li key={hit.id} className="w-full pt-4 pb-4 first:pt-0 md:pt-6 md:pb-6">
							<HitCard hit={hit} />
						</li>
					))}
				</ul>
			</SearchResultList>
			<Pagination />
		</div>
	);
};
